module.exports = __webpack_public_path__ + "img/mess.0a5b7f7b.svg";